import { AfterContentInit, Component } from '@angular/core';
import { UserProfileEntity } from 'src/shared/model/UserProfile';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { ActivatedRoute, Params } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { AbstractDataProvider } from '../AbstractDataProvider';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import {getErrorMessageText} from '../helper';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [DictionaryPipe]
})

export class ResetPasswordComponent implements AfterContentInit {
  userProfile: UserProfileEntity = new UserProfileEntity();

  display: boolean;
  alertMessage: string;
  logoImageUrl: string;
  clientCode: string;
  showPassword: boolean;
  showConfirmPassword: boolean;
  displaySuccessMessage: boolean;
  successMessage: string;

  private userId: string;
  private token: string;

  constructor(
    private authService: AuthServiceCustom,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private abstractDataProvider: AbstractDataProvider,
    private dictionaryPipe: DictionaryPipe) {

    this.route.queryParams.subscribe((queryParam: Params) => {
      this.userId = queryParam.userId;
      this.token = queryParam.token;

      if (!this.userId || !this.token) {
        this.authService.navigateToLogin();
      }

    });
  }


  ngAfterContentInit() {
    this.clientCode = this.authService.clientCode;
    this.logoImageUrl = this.authService.clientLogoUrl;
    this.authService.accessTokenRemovedSubj.next(true);
  }

  submit() {
    if (!this.userProfile.Password) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_NEW_PASSWORD');
      return;
    }
    if (!this.userProfile.ConfirmPassword) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_CONFIRM_PASSWORD');
      return;
    }
    if (this.userProfile.Password !== this.userProfile.ConfirmPassword) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('NEW_PASSWORD_AND_CONFIRM_DONT_MATCH');
      return;
    }
    if (!this.authService.passwordRegExp.test(this.userProfile.Password)) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('PASSWORD_DOESNT_SATISFY');
      return;
    }

    const dto = {
      UserId: this.userId,
      Token: this.token,
      NewPassword: this.userProfile.Password
    };
    this.abstractDataProvider.postData(dto, 'api/Accounts/ResetPasswordByToken').subscribe(
      () => {
        this.displaySuccessMessage = true;
        this.successMessage = this.dictionaryPipe.transform('PASSWORD_CHANGED_SUCCESSFULLY');
      },
      error => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );
  }

  preventPaste(e: any): void {
    e.preventDefault();
  }

  onConfirm() {
    this.display = false;
  }

  navigateHome() {
    this.authService.navigateToLogin();
  }

  cancel() {
    this.authService.navigateToLogin();
  }
}
